import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import confirm from "webmodals/confirm";
import labels from "servicestack/data-files/_labels";
// import DataFilePrompt from "servicestack/data-files/data-file-prompt";
// import ApplyTagsPrompt from "servicestack/data-files/apply-tags-prompt";

export default class DataFileContainerController extends BasicAutoQueryController {
  getQuery() {
    const $ctrl = this;
    $ctrl.labels = labels;
    return {
      url: "QueryDataFiles.json",
      hideLeftNav: true, // $ctrl.$page.is('gt-sm'),
      orderBy: "-LastWriteTimeUtc,Name",
      filters: [
        { groupBy: "IsBackup", title: "Status" },
        { date: "LastAccessTimeUtc", title: labels.lastAccessTimeUtc },
        { date: "LastWriteTimeUtc", title: labels.lastWriteTimeUtc },
        {
          number: "Length",
          title: labels.length,
          min: 0,
          max: 2000,
          step: 0.01
        }
      ],
      sortOptions: {
        Name: "Name: A to Z",
        "-Name": "Name: Z to A",
        "Length,Name": labels.length,
        "-Length,Name": labels.length,
        "IsBackup,Name": "Backup",
        "-IsBackup,Name": "Backup",
        "LastAccessTimeUtc,Name": labels.lastAccessTimeUtc,
        "-LastAccessTimeUtc,Name": labels.lastAccessTimeUtc,
        "LastWriteTimeUtc,Name": labels.lastWriteTimeUtc,
        "-LastWriteTimeUtc,Name": labels.lastWriteTimeUtc
      },
      onLoaded: args => $ctrl.onDataFilesLoaded(args),
      autoLoad: true,
      pageSize: 12
    };
  }

  onDataFilesLoaded(args) {
    console.debug("QueryDataFiles.json", { args, $ctrl: this });
  }

  delete(df) {
    const $ctrl = this;
    return confirm("Are you sure?", "Delete Data File").result.then(() =>
      $ctrl.query.bus
        .send("DeleteDataFile.json", df)
        .then(() => $ctrl.query.load(true))
    );
  }

  syncImages() {
    const $ctrl = this;
    $ctrl.waiting = true;
    return confirm(
      `Are you sure? This may take a while...`,
      "Sync Media/Images..."
    )
      .result.then(() => $ctrl.bus.send("SyncImages.json"))
      .then(res => {
        console.debug(res);
        $ctrl.waiting = false;
      });
  }

  download() {
    const $ctrl = this;
    return confirm(
      `This will download new database from the cloud and sync to your local device.`,
      "Are you sure?"
    )
      .result.then(() => $ctrl.$session.requestDataFile())
      .then(() => $ctrl.query.load(true));
  }

  upload() {
    const $ctrl = this;
    return confirm(
      `Unfortunately this feature has not been implemented yet`,
      "Coming soon..."
    ).result;
  }
}
